export const SMALL_IMAGE_MAX_WIDTH = 200
export const LARGE_IMAGE_MAX_WIDTH = 600
export const COMMON_ORIGINAL_WIDTH = 3000
export const ASPECT_RATIO = 4 / 3
